const styles = ({ COLORS, BREAKPOINTS }) => ({
  selectAll: {
    color: COLORS.BLUE.NORMAL,
    cursor: 'pointer',
    fontWeight: 'bold',
    userSelect: 'none'
  },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px 0 0'
  },
  container: {
    overflowX: 'auto'
  },
  nameCell: {
    textAlign: 'left',
    paddingLeft: '54px'
  },
  alignLeft: {
    textAlign: 'left'
  }
})

export default styles
